<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/innoknight/logo.png" width="37" height="48" alt="InnoKnight" v-if="!logotext">
        <img class="navbar-brand-minimized" src="img/innoknight/logo.sm.png" width="23" height="30" alt="InnoKnight" v-if="!logotext">
        <span class="navbar-brand-full" v-if="logotext">{{logotext}}</span>
        <span class="navbar-brand-minimized" v-if="logotext">{{logotext}}</span>
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="">
          <DefaultHeaderDropdown/>
        </b-nav-item>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb class="hidden" :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>

        <b-modal v-model="showPrivacyModal" :ok-title="$t('confirm')" :ok-only="true" size="xl">
          <div class="animated fadeIn">
            <h1 class="text-primary">會員服務條款</h1>
            <br>
            <p class="text-dark">非常歡迎您光臨「創玖科技充電計費服務網站」（以下簡稱本網站），為了讓您能夠安心的使用本網站的各項服務與資訊，特此向您說明本網站的隱私權保護政策，以保障您的權益，請您詳閱下列內容：</p>
            <br>
            <h3 class="text-primary">一、隱私權保護政策的適用範圍</h3>
            <p class="text-dark">隱私權保護政策內容，包括本網站如何處理在您使用網站服務時收集到的個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。</p>
            <br>
            <h3 class="text-primary">二、個人資料的蒐集、處理及利用方式</h3>
            <ul class="text-dark">
              <li>當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性質，請您提供必要的個人資料，並在該特定目的範圍內處理及利用您的個人資料；非經您書面同意，本網站不會將個人資料用於其他用途。</li>
              <li>本網站在您使用服務信箱、問卷調查等互動性功能時，會保留您所提供的姓名、電子郵件地址、聯絡方式及使用時間等。</li>
              <li>於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的 IP 位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為我們增進網站服務的參考依據，此記錄為內部應用，決不對外公佈。</li>
              <li>為提供精確的服務，我們會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。</li>
              <li>您可以隨時向我們提出請求，以更正或刪除本網站所蒐集您錯誤或不完整的個人資料。</li>
            </ul>
            <br>
            <h3 class="text-primary">三、資料之保護</h3>
            <ul class="text-dark">
              <li>本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。</li>
              <li>如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。</li>
            </ul>
            <br>
            <h3 class="text-primary">四、服務費率</h3>
            <p class="text-dark">本服務之費率依各充電站公告為準，可能包含但不限於以下費用：</p>
            <ul class="text-dark">
              <li>充電電量費：依實際充電電量（kWh）計算。</li>
              <li>充電時間費：依充電時間計算。</li>
              <li>服務費：本公司為提供充電平台服務所收取之費用。</li>
              <li>佔位費（Idle Fee）：充電完成後未移車所產生之費用。</li>
            </ul>
            <p class="text-dark">各充電站之費率可能不同，並將於以下位置公告：</p>
            <ul class="text-dark">
              <li>各充電樁充電頁面。</li>
              <li>充電站現場資訊。</li>
              <li>本公司充電地圖。</li>
            </ul>
            <p class="text-dark">本公司保留隨時調整費率之權利，調整後之費率將於平台公告後生效。</p>
            <p class="text-dark">會員於開始充電前，應自行確認相關費率。</p>
            <br>
            <h3 class="text-primary">五、扣款方式</h3>
            <p class="text-dark">會員使用本服務進行充電時，本公司將依充電紀錄計算費用，並透過會員所設定之付款方式進行扣款。</p>
            <p class="text-dark">本服務可能提供以下付款方式：</p>
            <ul class="text-dark">
              <li>信用卡。</li>
              <li>行動支付（例如 LINE Pay）。</li>
              <li>儲值金。</li>
              <li>第三方支付服務。</li>
            </ul>
            <p class="text-dark">若會員綁定信用卡或電子支付帳戶，本公司得於以下時間進行扣款：</p>
            <ul class="text-dark">
              <li>充電結束後。</li>
              <li>每筆交易完成時。</li>
            </ul>
            <p class="text-dark">會員同意授權本公司或其合作金流機構依實際交易金額進行扣款。</p>
            <p class="text-dark">若付款方式發生以下情形，本公司得暫停服務：</p>
            <ul class="text-dark">
              <li>授權失敗。</li>
              <li>帳戶餘額不足。</li>
              <li>信用卡過期。</li>
              <li>銀行拒絕交易。</li>
            </ul>
            <p class="text-dark">若扣款失敗，會員將在下次充電時補繳相關費用。</p>
            <br>
            <h3 class="text-primary">六、交易行為</h3>
            <p class="text-dark">會員使用本服務所產生之充電行為，均視為有效交易。</p>
            <p class="text-dark">本公司將依以下資訊記錄交易內容：</p>
            <ul class="text-dark">
              <li>充電站位置。</li>
              <li>充電開始與結束時間。</li>
              <li>充電電量。</li>
              <li>交易金額。</li>
            </ul>
            <p class="text-dark">上述資料將作為交易與扣款之依據。</p>
            <p class="text-dark">會員可透過本公司網站查詢交易紀錄。</p>
            <p class="text-dark">若會員對交易內容有疑義，應於30日內 提出申請。</p>
            <br>
            <h3 class="text-primary">七、信用卡交易</h3>
            <p class="text-dark">會員可於本服務綁定信用卡作為支付工具。</p>
            <p class="text-dark">會員同意本公司透過合法金流服務機構處理信用卡交易。</p>
            <p class="text-dark">在本服務中會員所輸入信用卡資訊之頁面，均由該第三方金流服務商提供並管理之，與本公司無涉。為保護使用者的隱私以及個人資料安全，本公司不會直接儲存任何信用卡資訊。</p>
            <p class="text-dark">當會員完成充電交易後，本公司將依實際費用向信用卡進行授權與請款。</p>
            <p class="text-dark">若發生以下情形，本公司得暫停會員使用服務：</p>
            <ul class="text-dark">
              <li>信用卡授權失敗。</li>
              <li>信用卡失效。</li>
              <li>銀行拒絕交易。</li>
              <li>交易疑似異常或詐欺。</li>
            </ul>
            <p class="text-dark">若會員提出信用卡爭議交易（Chargeback），本公司得：</p>
            <ul class="text-dark">
              <li>暫停會員帳號。</li>
              <li>要求會員提供相關證明。</li>
              <li>暫停後續服務。</li>
            </ul>
            <br>
            <h3 class="text-primary">八、異常交易與退款</h3>
            <p class="text-dark">會員如遇以下情形，可向本公司申請交易確認或退款：</p>
            <ul class="text-dark">
              <li>重複扣款。</li>
              <li>系統計費錯誤。</li>
              <li>交易異常。</li>
            </ul>
            <p class="text-dark">退款方式將依原付款方式處理，例如：</p>
            <ul class="text-dark">
              <li>信用卡退刷。</li>
              <li>行動支付退款。</li>
              <li>儲值金退回帳戶。</li>
            </ul>
            <p class="text-dark">如無法依原付款方式處理時，需提供匯款帳號以匯款方式處理。</p>
            <br>
            <h3 class="text-primary">九、儲值金與退款</h3>
            <p class="text-dark">會員儲值金無使用期限。若您因故欲退還儲值金不再使用，請透過"創玖科技官方LINE群"或播打客服電話035775036由專人協助辦理。</p>
            <p class="text-dark">會員經完成儲值後需申請退款時，需全額退費，恕無法辦理部份餘額退費。儲值金退費作業時間為 14-20 個工作天，退費金額須先扣除手續費及您購買金額時所取得之紅利（退還金額 = 餘額金額 – 紅利 – 手續費 ）。</p>
            <p class="text-dark">退款時，手續費 = 餘額金額的3% + 行政費用30元</p>
            <br>
            <h3 class="text-primary">十、網站對外的相關連結</h3>
            <p class="text-dark">本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。</p>
            <br>
            <h3 class="text-primary">十一、與第三人共用個人資料之政策</h3>
            <p class="text-dark">本網站絕不會提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。</p>
            <p class="text-dark">前項但書之情形包括不限於：</p>
            <ul class="text-dark">
              <li>經由您書面同意。</li>
              <li>法律明文規定。</li>
              <li>為免除您生命、身體、自由或財產上之危險。</li>
              <li>與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集者依其揭露方式無從識別特定之當事人。</li>
              <li>當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</li>
              <li>有利於您的權益。</li>
              <li>本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。</li>
            </ul>
            <br>
            <h3 class="text-primary">十二、Cookie 之使用</h3>
            <p class="text-dark">為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的 Cookie，若您不願接受 Cookie 的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕 Cookie 的寫入，但可能會導致網站某些功能無法正常執行 。</p>
            <br>
            <h3 class="text-primary">十三、隱私權保護政策之修正</h3>
            <p class="text-dark">本網站隱私權保護政策將因應需求隨時進行修正，修正後的條款將刊登於網站上。</p>
            <br>
          </div>
        </b-modal>
      </main>
      <!-- <AppAside fixed>
        <!--aside-->
        <!-- <DefaultAside/> -->
      <!-- </AppAside> -->
    </div>
    <TheFooter>
      <!--footer-->
      <div class="ml-auto">
        <!--<router-link to="privacy">{{$t('privacy_policy')}}</router-link>。-->
        <span @click="popPrivacyModal" class="clickable-text">{{$t('privacy_policy')}}</span>。
        <span v-html="PrivacyPolicy"></span>
        {{$t('innoknight') + '©' + thisyear}} 
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'
import config from '@/config/global'

export default {
  name: 'SearchContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    // AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      let app         = this;
      let adminuser   = this.$state.$get('adminuser');
      let enduser     = this.$state.$get('user');
      let is_frontend = false;

      // console.info('enduser: ', enduser);
      // console.info('adminuser: ', adminuser);

      if(enduser && enduser._nav && enduser._nav.length){
        app.navItems = [];
        let updated_is_front = false;
        enduser._nav.map((menu) => {
          //i18n
          //console.info('menu.name: ', menu.name);
          switch(menu.name){
            case '充電裝置':
              menu.name = this.$t('default_container.menu.showdevice');
              break;
            case '充電紀錄':
              menu.name = this.$t('default_container.menu.history');
              break;
            case '交易紀錄':
              menu.name = this.$t('default_container.menu.transactions');
              break;
            case '充電地圖':
              menu.name = this.$t('default_container.menu.maps');
              break;
            case '會員專區':
              menu.name = this.$t('default_container.menu.members-setting');
              break;
            default:
              break;
          }
          
          let badge = null;
          if(menu.badge && menu.badge.length > 2){
            try {
              badge = JSON.parse(menu.badge);
            } catch (error) {console.error(`Unable to parse JSON badge from ${menu.name} with value: ${menu.badge}`);}
          }
          menu.badge = badge;
          app.navItems.push(menu);

          if(!updated_is_front){
            if(app.$route.fullPath.indexOf(menu.url) !== -1){
              is_frontend      = true;
              updated_is_front = true;
            };
          }
        });
      }

      if(!is_frontend && adminuser && adminuser._nav && adminuser._nav.length){
        app.navItems = [];
        let ccff = this.$state.$get('ccff');
        console.info('ccff:', ccff);

        adminuser._nav.map((menu) => {
          let badge = null;
          if(menu.badge && menu.badge.length > 2){
            try {
              badge = JSON.parse(menu.badge);
            } catch (error) {console.error(`Unable to parse JSON badge from ${menu.name} with value: ${menu.badge}`);}
          }

          if(ccff !== 'N/A' && menu.is_sudo){
            return true;
          }

          menu.badge = badge;
          app.navItems.push(menu);
        });
      }

      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    PrivacyPolicy() {
      const link = `<a href="https://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=I0050021" target="_blank">${this.$t('personal_data_protection_act')}</a>`;
      return this.$t('privacy_policy_message', { link });
    }
  },//eo computed

  data () {

    const this_year = new Date();

    return {
      navItems: [],
      footer: config.footer,
      logotext: config.logotext,
      thisyear: this_year.getFullYear(),
      showPrivacyModal: false
    }
  },//eo data

  beforeMount() {
    let user = this.$state.$get(('user'));
    let is_showsearch = this.$route.path.indexOf('/search/devices') !== -1;

    if(this.$route && this.$route.query && this.$route.query.keyword){
      this.$state.$set('keyword', this.$route.query.keyword);
    }

    //console.info('keyword:', this.$state.$get('keyword'));

    if(!user && !is_showsearch){
      let target = '/';
      this.$state.$set('error', config.error.INVALID_USER);
      this.$router.push(target);
    } else {
      this.userprofile = user;
    }

    return false;
  },//eo beforeMount

  mounted() {
    if(config.overwritetitle){
      // console.info('config.overwritetitle:', config.overwritetitle);
      document.title = config.overwritetitle;
    }
  },

  methods: {
    popPrivacyModal() {
      this.showPrivacyModal = true;
    }
  },

}
</script>

<style type="text/css">
.grecaptcha-badge{
  display: none;
}
.app-footer{
  text-align: justify;
}
.modal .modal-xl {
	max-width: 90% !important;
    width: 90% !important;
}
.clickable-text {
  cursor: pointer;
  color: #3366BB;
  text-decoration: underline;
}
</style>
